import { useNavigate, useOutletContext, useParams, useSearchParams } from "react-router-dom";

import CertificateDetail from "../components/CertificateDetail";

export default function CertificateRoute() {
  const { orderId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { data } = useOutletContext();
  const certificateIndex = parseInt(searchParams.get("index") || "0", 10);

  if (!data) {
    return null;
  }

  const cert = data["line_items"][certificateIndex];
  if (!cert) {
    return null;
  }

  const handleClose = () => {
    navigate(`/orders/${orderId}`);
  };

  return (
    <CertificateDetail
      cert={cert}
      certificateIndex={certificateIndex}
      onClose={handleClose}
      printDate={data["print_date"]}
    />
  );
}
